import { Box, Typography } from '@mui/material'
import React from 'react'

interface propTypes {
  title: string
  specs: string[]
  img: string
}
const ProductsCard: React.FC<propTypes> = (props) => {
  const { title, specs, img } = props
  return (
    <Box
      sx={{
        border: '1px solid #fff',
        px: 4,
        py: 3,
        borderRadius: '8px',
        textAlign: 'center',
        mb: { xs: 3 },
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, mx: 'auto' }}>
        {title}
      </Typography>
      {specs.map((spec, index) => (
        <Typography sx={{ width: '250px', mx: 'auto' }} key={index}>
          {spec}
        </Typography>
      ))}
      <img
        src={img}
        alt="Stx Box"
        style={{ width: '200px', marginTop: '40px' }}
      />
    </Box>
  )
}

export default ProductsCard
